import { completedCourses } from 'components/organisms/UpDashboard/constants';
import CourseList from '../../CourseList';

export default function Completed() {
  return <CourseList courses={completedCourses} />;
}
